import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import {
  GetSeatmapsState,
  resetGetSeatmaps,
  selectGetSeatmapsIsFailureStatus,
  selectGetSeatmapsState,
  setGetSeatmapsFromApi,
} from '@common/store';
import { ApiErrorResponseService, ErrorsHandlerService } from '@lib/services';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { DefaultService as Api, GetSeatmapsRequest, GetSeatmapsResponse } from 'src/sdk-servicing';

@Injectable({
  providedIn: 'root',
})
export class GetSeatmapsStoreService extends ServicingBaseClass {
  private _result$: Observable<GetSeatmapsState>;
  private _result!: GetSeatmapsState;
  get result() {
    return this._result;
  }

  /** APIエラーSubscription */
  apiErrorResponseSubscription?: Subscription;

  constructor(
    private _store: Store<GetSeatmapsState>,
    private _api: Api,
    private _apiErrorResponseService: ApiErrorResponseService,
    private _errorsHandlerService: ErrorsHandlerService
  ) {
    super();
    this._result$ = this._store.pipe(
      select(selectGetSeatmapsState),
      filter((data) => !!data)
    );
    this.subscribeService(this._result$, (data) => {
      this._result = data;
    });
  }

  override destroy(): void {
    if (!!this.apiErrorResponseSubscription) {
      this.apiErrorResponseSubscription.unsubscribe();
      this.apiErrorResponseSubscription = undefined;
    }
    this.clear();
  }

  /**
   * エラーが発生しているGetSeatmapsStateのObservableを返却する
   */
  get failure$(): Observable<GetSeatmapsState> {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  /**
   * GetSeatmapsStateのObservableを返却する
   * @returns GetSeatmapsState の全ての値を取得するObservable
   */
  public getResultState$() {
    return this._result$;
  }

  /**
   * PostSeatmapResponseDataを取得するObservableを返却する
   * @returns
   */
  public getResponse$() {
    return this._result$.pipe(filter((data) => !!data.model?.data));
  }

  /**
   * シートマップ取得が正常終了したら結果を取得するObservable
   */
  getResultStateIfSuccessful$() {
    return this._result$.pipe(filter((state) => !state.isFailure && !state.isPending && !!state.model));
  }

  /**
   * API呼び出し結果のObservableを受け取りStoreに格納する
   * @param call API呼び出し結果を取得するObservable
   */
  private setResult(call: Observable<GetSeatmapsResponse>) {
    this._store.dispatch(setGetSeatmapsFromApi({ call }));
  }

  /**
   * シートマップ取得のストアをクリアする
   */
  public clear() {
    this._store.dispatch(resetGetSeatmaps());
  }

  /**
   * シートマップ取得APIの呼び出しと、呼び出し結果のStoreへの設定を行う
   *
   * エラーハンドリングの設定は、呼び出しもとで実施する。
   */
  callApi(condition: GetSeatmapsRequest) {
    const call = this._api.getSeatmapsPost(condition);
    this.setResult(call);
  }
}
